import Vue from 'vue'
import ptiMixin from '@/utils/pti/ptiMixin'
import { devLog } from '@/utils'
import '@/utils/pti/fallDetector'
import '@/utils/pti/perimeterDetector'
import '@/utils/pti/inactivityDetector'

const _webViewOptimisation = () => {
  const { backgroundMode } = cordova.plugins
  backgroundMode.disableWebViewOptimizations()
}

const { cordova } = window

export default new Vue({
  name: 'Pti',
  mixins: [ptiMixin],
  beforeCreate () {
    if (cordova) {
      document.addEventListener(
        'deviceready', () => {
          const { backgroundMode } = cordova.plugins
          backgroundMode.setDefaults({
            title: process.env.APP.simpleName,
            text: `Mode PTI actif`,
            // silent: true
            icon: 'ic_launcher', // this will look for icon.png in platforms/android/res/drawable|mipmap
            // color: 'F14F4D', // hex format like 'F14F4D'
            resume: true,
            hidden: false,
            bigText: false
          })
          backgroundMode.un('activate', _webViewOptimisation)
          backgroundMode.on('activate', _webViewOptimisation)
        },
        true)
    }
  },
  destroyed () {
    if (cordova) {
      const { backgroundMode } = cordova.plugins
      backgroundMode.un('activate', _webViewOptimisation)
    }
  },
  methods: {
    _onActiveStateChange () {
      devLog('Mode PTI : ', this.isActive)
      const handleStateChange = () => {
        const { backgroundMode } = cordova.plugins
        backgroundMode.setEnabled(this.isActive)
        if (this.isActive) {
          backgroundMode.overrideBackButton()
        }
      }
      if (cordova && cordova.plugins && cordova.plugins.backgroundMode) {
        return handleStateChange()
      }
      document.addEventListener(
        'deviceready',
        handleStateChange
      )
    }
  }
})
